import React, { useState, useContext, useEffect } from "react";
import { Form, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Axios from 'axios';
import { useForm } from "react-hook-form";
import { useHistory } from 'react-router-dom';
import Input from './common/Input';
import { AuthContext } from '../context/auth-context';
import { CoreContext } from '../context/core-context';


const AddUser = (props) => {

    const authContext = useContext(AuthContext);
    const coreContext = useContext(CoreContext);

    const history = useHistory();

    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [district, setDistrict] = useState('');
    const [address, setAddress] = useState('');
    const [ayear, setAyear] = useState('');
    const [pyear, setPyear] = useState('');
    const [contact1, setContact1] = useState('');
    const [contact2, setContact2] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [role, setRole] = useState('');
    const [nationality, setNationality] = useState('Indian');
    const [sCategory, setSCategory] = useState('');
    const [organization, setOrganization] = useState('');
    const [department, setDepartment] = useState('');
    const [designation, setDesignation] = useState('');
    const [accomodation, setAccomodation] = useState('');
    const [presenting, setPresenting] = useState('');
    const [accompanying, setAccompanying] = useState('');
    const [declaration, setDeclaration] = useState(false);
    const [aClassOptions] = useState(coreContext.admissionClassOptions);
    const [pClassOptions] = useState(coreContext.passOutClassOptions);

    const [nationalityOptions] = useState([{ name: 'Indian', value: 'Indian' }, { name: 'Others', value: 'Others' }]);
    const [yesNoOptions] = useState([{ name: 'Select', value: '' },{ name: 'Yes', value: 'yes' }, { name: 'No', value: 'no' }]);

    //{ name: 'Not Presenting', value: 'no' },
    const [presentingOptions] = useState([{ name: 'Select One', value: '' }, { name: 'Invited Talk', value: 'Invited Talk' },{ name: 'Contributed Talk', value: 'Contributed Talk' },{ name: 'Poster Presentation', value: 'Poster Presentation' },]);

    const [accompanyingOptions] = useState([{ name: 'None', value: 'no' },{ name: 'One', value: '1' },{ name: 'Two', value: '2' },{ name: 'Three', value: '3' },{ name: 'Four', value: '4' },{ name: 'Five', value: '5' },{ name: 'Six', value: '6' },{ name: 'Seven', value: '7' },{ name: 'Eight', value: '8' },{ name: 'Nine', value: '9' },{ name: 'Ten', value: '10' },]);

    const [sRoleOptions] = useState(coreContext.applicantCategories);


    const { register, handleSubmit, errors } = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onBlur',
    });
    // const onSubmit = data => console.log(data);

    const roleOptions = () => {
        coreContext.fetchRoleOptions();
    }

    useEffect(roleOptions, []);

    const showFields = () => {

        if (sCategory == 1)
            return <>
                <Input label='Admission Year' name='ayear' onChange={(e) => setAyear(e.target.value)} minLength={4} maxLength={4} required={true} register={register} errors={errors} elementType='text' placeholder='Enter Admission Year eg. 2014' />

                <Input label='Passout Year' name='pyear' onChange={(e) => setPyear(e.target.value)} minLength={4} maxLength={4} required={true} register={register} errors={errors} elementType='text' placeholder='Enter Passout Year eg. 2014' />

            </>

        else return <>
            <Input label='Joining Date in Jnv' value={ayear} onChange={(e) => setAyear(e.target.value)} minLength={10} maxLength={10} required={true} register={register} errors={errors} elementType='date' placeholder='Joining Date in Jnv' />

            <Input label='Joining Date (Current Jnv)' onChange={(e) => setPyear(e.target.value)} name='pyear' minLength={10} maxLength={10} required={true} register={register} errors={errors} elementType='date' placeholder='Joining Date in current Jnv' />
        </>
    }


    const setPathName = ()=>{
        coreContext.setPathName(props.location.pathname);

        const website = authContext.ownerId ? authContext.ownerId : localStorage.getItem('app_ownerId')?localStorage.getItem('app_ownerId'):  props.match.params.website;
        if(website) {
            authContext.setOwnerId(website); // fetch logo dynamically here
            localStorage.setItem('app_ownerId', website);
            } else window.location='https://swabhimanjnv.in/join-us';
    }

    useEffect(setPathName, []);

    const signUpHandler = (data) => {
        if(authContext.ownerId)
            Axios.post('/sign-up', { email, password, name, userId: authContext.ownerId, itemId: authContext.ownerId, contact1, contact2, nationality, sCategory, organization, designation, accomodation, presenting, accompanying, department, district, address, ayear, pyear }).then(response => {
            authContext.setShowLoader(false);
            // console.log('after signup', response.data);
            const value = response.data.message;
            authContext.setMessage(value);
          //  createPages(response.data.data.itemId, response.data.data.userId);
          
          authContext.login(email, password, '/');

        }).catch(err => {
            const value = err.response.data.data;
            authContext.setMessage(value[0].msg);
            authContext.setShowLoader(false);
        })


     else  alert('Error! Branch could not indentified !!');

    }




    const onEmailChangedHandler = (e) => {
        setEmail(e.target.value);
    }

    const onContact1Handler = (e) => {
        setContact1(e.target.value);
    }

    const onContact2Handler = (e) => {
        setContact2(e.target.value);
    }

    const aDeclaration = (e) => {
        setDeclaration(!declaration);
    }

    const onNameChangedHandler = (e) => {
        setName(e.target.value);
    }

    const onPasswordChangedHandler = (e) => {
        setPassword(e.target.value);
        verifyPassword(e.target.value, confirmPassword);
    }

    const onConfirmPasswordChangedHandler = (e) => {
        setConfirmPassword(e.target.value);
        verifyPassword(password,e.target.value, );
    }

    const verifyPassword = (p, cp) => {
if(p !== cp)
    authContext.setMessage('Password and confirm password do not match..');
    else
    authContext.setMessage('');


    }


    return (
        <div className='container'>
            <div className="row">
                <div className="col-md-2"></div>
                <div className="col-md-8">
                    <div className="card">
                        <div className="card-title mx-auto"><h3><Badge variant="success">Regiser Yourself</Badge></h3></div>
                        <div className="card-body">
                            <Form autoComplete='off' onSubmit={handleSubmit(signUpHandler)} noValidate>
                                <Input label='Name' name='name' minLength={5} maxLength={55} required={true} register={register} errors={errors} elementType='text' placeholder='Enter Name' onChange={onNameChangedHandler} />

                                {/* <Input label='Designation' name='designation' minLength={2} maxLength={55} required={true} register={register} errors={errors} elementType='text' placeholder='Enter designation' onChange={(e)=> setDesignation(e.target.value)} /> */}

                                <Input label='Email' name='email' required={true} register={register} errors={errors} elementType='email' minLength={5} maxLength={55} pattern={/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/} placeholder='Enter Email' onChange={onEmailChangedHandler} />

                                <Input label='Mobile' name='contact1' minLength={10} maxLength={10} required={true} register={register} errors={errors} elementType='text' placeholder='Enter Mobile no.' onChange={onContact1Handler} />

                                
                                <Input label='Nationality' name='nationality' required={true} register={register} errors={errors} elementType='select' options={nationalityOptions} onChange={(e) => setNationality(e.target.value)} />

                                {/* <Input label='Department' name='department' minLength={2} maxLength={55} required={true} register={register} errors={errors} elementType='text' placeholder='Enter your department name' onChange={(e)=> setDepartment(e.target.value)} />

                                <Input label='Institute / Organization' name='organization' minLength={2} maxLength={55} required={true} register={register} errors={errors} elementType='text' placeholder='Enter Institute / Organization name' onChange={(e)=> setOrganization(e.target.value)} /> */}

                                <Input label='Password' required={true} register={register} errors={errors} name='password' minLength={5} maxLength={55} elementType='password' placeholder='Enter Password' onChange={onPasswordChangedHandler} />

                                <Input label='Confirm Password' required={true} register={register} errors={errors} name='copassword' minLength={5} maxLength={55} elementType='password' placeholder='Enter Confirm Password' onChange={onConfirmPasswordChangedHandler} />

                                {/* <Input label='Presentation Mode' name='presenting' required={true} register={register} errors={errors} elementType='select' options={presentingOptions} onChange={(e)=> setPresenting(e.target.value)} /> */}
  
                                <Input label='Category' name='category' required={true} register={register} errors={errors} elementType='select' options={sRoleOptions} onChange={(e) => setSCategory(e.target.value)} />

                                <Input label='Jawahar Navodaya Vidyalaya District' name='district' minLength={2} maxLength={55} required={true} register={register} errors={errors} elementType='text' placeholder='Enter JNV District Name' onChange={e => setDistrict(e.target.value)} />

                                {showFields()}
{/*                                
                                <Input label='Accomodation Required' name='accomodation' required={true} register={register} errors={errors} elementType='select' options={yesNoOptions} onChange={(e)=> setAccomodation(e.target.value)} />
                              
                                <Input label='Accompanying Person Count' name='accompanying' required={true} register={register} errors={errors} elementType='select' options={accompanyingOptions} onChange={(e)=> setAccompanying(e.target.value)} /> */}

<Input label='Please read the declaration below and tick this box to accept & proceed' name='declaration' required={true} register={register} errors={errors} elementType='checkbox'  onChange={aDeclaration} />

मैंने SWABHIMAN BEING A NAVODIAN से जुड़ने, सहयोग करने संबंधित सभी जानकारी प्राप्त कर ली है | <br/> मैंने वेबसाइट पर नियमावली को पढ़ लिया है | <br/> मैं सभी नियमों एवं शर्तों से सहमत हूँ | <br/> यदि मैं संस्था द्वारा बनाये गये नियमों के अंतर्गत सहयोग नहीं करता / करती हूँ तो मेरे अथवा परिवार के सदस्यों द्वारा सहयोग प्राप्त करने का दावा नहीं किया जाएगा |

<br/> <br/>


                              {password && confirmPassword && confirmPassword === password && declaration ?  <Input elementType='button' variant='primary' />: ''} &nbsp;&nbsp; {authContext.ren}
                                <Input variant='danger' label={authContext.message} elementType='label' /> &nbsp;&nbsp;  
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}



export { AddUser };